export type DAChatId = string;

export interface DAFile {
  id: string;
  name: string;
  status: ExtractionStatus;
}

export interface DAChat {
  id: DAChatId;
  name: string;
  files: DAFile[];
  date: string;
  status: ExtractionStatus;
  messages: DAMessage[];
}

export interface DAMessage {
  id: string;
  role: DAMessageRole;
  date: string;
  parts: DAMessagePart[];
}

export interface DAMessagePart {
  type: DAMessagePartType;
  content: string | DAMessageSource | DAMessageAction | DAMessageACK;
}

export interface DAMessageSource {
  source_id: string;
  document_id: string;
  document: string;
  page: number;
  bboxes: number[][];
}

export interface DAMessageAction {
  action: string;
  table: number;
}

export interface DAMessageACK {
  id: string;
  role: DAMessageRole;
  date: string;
}

export type DASavedQuestionId = string;

export interface DASavedQuestion {
  id: string;
  title?: string;
  question: string;
}

export type UploadId = string;

export interface WithUploadId {
  uploadid: UploadId;
}

export interface FileUpload extends WithUploadId {
  name: string;
}

export interface FileUploadStats extends FileUpload {
  progress: number;
}

export interface FileUploaded extends FileUpload {
  id: string;
}

export interface FileUploadError extends FileUpload {
  errorCodes: string[];
}

export interface ProgressActionPayload extends WithUploadId {
  progress: number;
}

export type DADataTableId = string;

export interface DADataTable {
  id: DADataTableId;
  name: string;
  date: Date;
  tags: DADataTableTag[];
  individual?: boolean | number | string;
}

export interface DADataTableTemplate extends DADataTable {
  description: string;
}

export interface DADataTableTemplate extends DADataTable {
  description: string;
}

export interface DADataTableTag {
  name: string;
  description?: string;
  example?: string;
}

export interface PDFViewerInfo {
  token: string;
  source_id: string;
  document_id: string;
  document: string;
  page: number;
  bboxes: number[][];
  messageID: string;
}

export interface IChatState {
  chats: Record<DAChatId, DAChat>;
  activeChat: DAChatId | undefined;
  uploads: Record<UploadId, FileUploadStats>;
  uploaded: Record<UploadId, FileUpload>;
  dataTables: DADataTable[];
  dataTablesTemplates: DADataTableTemplate[];
  PDFViewerInfo: PDFViewerInfo | undefined;
  savedQuestions: DASavedQuestion[];
}

export enum ExtractionStatus {
  Done = 'done',
  Failed = 'failed',
  Running = 'running',
  Empty = 'empty',
  Queued = 'queued',
}

export enum DAMessageRole {
  USER = 'user',
  ASSISTANT = 'assistant',
}

export enum DAMessagePartType {
  TEXT = 'text',
  SOURCE = 'source',
  ACTION = 'action',
  ACK = 'ack',
}
